import { Map as ImmutableMap, Set as ImmutableSet, List as ImmutableList, Record as ImmutableRecord } from 'immutable';
import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
import FlowRevision from 'automation-ui-canvas/flow/records/Flow/FlowRevision';
import * as ActionTypes from 'automation-ui-canvas/actions/ActionTypes';
import { transformFlowValidationResponse } from 'automation-ui-flow-core/validation/validationUtils';
import { FetchFlowRevisionActionTypes, FetchFlowValidationTypes, FetchFlowValidationObjectTypes, FetchHybridFlowPerformanceListCounts, FlowActionTypes } from 'automation-ui-canvas/actions/FlowActions';
import { getVersion } from 'automation-ui-canvas/flow/records/Flow/flowUtils';
const defaultUserEditedActionIds = {
  editedActionIds: ImmutableSet(),
  orderOfEditedActionIds: ImmutableList()
};
export const UserEditedActionIdsRecord = ImmutableRecord(defaultUserEditedActionIds);
class FlowsState extends createImmutableObjectClass({
  allFlowRevisions: ImmutableMap(),
  currentlyStagedFlow: null,
  hybridPerformanceListCounts: ImmutableMap(),
  userEditedActionIds: ImmutableMap(),
  validation: ImmutableMap()
}) {}
const initialState = new FlowsState();
export default ((state = initialState, action) => {
  switch (action.type) {
    case FetchFlowRevisionActionTypes.SUCCEEDED:
      {
        const {
          payload: {
            requestEntity: {
              flowId
            },
            response
          }
          // Best we can do until we have template literal types
        } = action;
        const flowRevision = new FlowRevision(response);
        const revisionId = getVersion(flowRevision);
        const newAllFlowRevisions = (state.getIn(['allFlowRevisions', flowId]) || ImmutableMap()).set(revisionId, flowRevision);
        return state.setIn(['allFlowRevisions', flowId], newAllFlowRevisions);
      }
    case ActionTypes.UPDATE_FLOW_LOCALLY:
      {
        const {
          payload: {
            flow
          }
          // Best we can do until we have template literal types
        } = action;
        return state.set('currentlyStagedFlow', flow);
      }
    case FlowActionTypes.ADD_USER_EDITED_ACTION_IDS:
      {
        const {
          action: flowAction,
          flow
        } = action.payload;
        if (flowAction) {
          const actionId = flowAction.isNew() ? flow.getNextAvailableActionId() - 1 : flowAction.actionId;
          return state.updateIn(['userEditedActionIds', flow.flowId], (record = UserEditedActionIdsRecord()) => record.update('editedActionIds', set => set.add(actionId)).update('orderOfEditedActionIds', list => list.push(actionId)));
        }
        return state;
      }
    case ActionTypes.REVERT_STAGED_CHANGES:
      return state.set('currentlyStagedFlow', null);
    case FetchHybridFlowPerformanceListCounts.SUCCEEDED:
      {
        const {
          requestEntity,
          response
        } = action.payload;
        return state.setIn(['hybridPerformanceListCounts', requestEntity], ImmutableMap(response));
      }
    case FetchFlowValidationTypes.SUCCEEDED:
      {
        const {
          payload
        } = action;
        return state.setIn(['validation', payload.requestEntity], transformFlowValidationResponse(payload.response));
      }
    case FetchFlowValidationObjectTypes.SUCCEEDED:
      {
        const {
          payload
        } = action;
        return state.setIn(['validation', payload.requestEntity.flowId], transformFlowValidationResponse(payload.response));
      }
    default:
      return state;
  }
});